// MultipleChoiceQuestion.tsx
import React from "react";
import { QuestionProps } from "./Question";

const MultipleChoiceQuestion: React.FC<QuestionProps> = ({
  id,
  question,
  options,
  onChange,
  currentAnswer, // 현재 답변 추가
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newAnswer = Number(e.target.value);
    onChange(id, newAnswer);
  };

  return (
    <div className="optionsbox">
      {options?.map((option, index) => (
        <div className="option-container" key={index}>
          <label className="optiontext">
            <input
              type="radio"
              name={`question-${id}`}
              value={index} // 인덱스를 value로 설정
              className="rdbtn"
              checked={currentAnswer === index} // 현재 답변과 비교
              onChange={handleChange}
            />
            <div className="option-number">
              {/* 조건부 렌더링으로 체크 표시 추가 */}
              {currentAnswer === index && (
                <div className="opt_checked">
                  <img
                    src="./assets/check.svg"
                    className="checksvg"
                    alt="img"
                  />
                </div>
              )}
              {index + 1}
            </div>
            <span>{option}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default MultipleChoiceQuestion;
